"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_GLOBAL_PRODUCT_TREE = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_GLOBAL_PRODUCT_TREE = (0, gql_1.gql)(`
  query globalProductTree {
    productTrees(filter: {
      title: {
        equals: "Global"
      }
    }) {
      edges {
        node {
          id
          myPermissions
        }
      }
    }
  }
`);
